import regEx from './regEx'

/**
 * Extracts the filename/path from a URL, stripping query parameters and fragments.
 *
 * @param url - The URL to extract the path from
 * @returns The filename/path without query parameters or fragments, or null/undefined if no match
 *
 * @example
 * getUrlPath('https://example.com/path/image.jpg?t=1234567890')
 * // Returns: 'image.jpg'
 *
 * getUrlPath('https://example.com/path/image.jpg#fragment')
 * // Returns: 'image.jpg'
 */
export const getUrlPath = (url: string): string | null | undefined => {
  if (!url) return null

  // Remove query parameters and fragments before extracting path
  // Split on '?' to remove query params, then on '#' to remove fragments
  const urlWithoutQueryAndFragment = url.split('?')[0].split('#')[0]

  return urlWithoutQueryAndFragment.match(regEx.urlPath)?.[0]
}

export default getUrlPath
